export const BLOG_CATEGORIES: {
    title: string;
    slug: "news"; //  | "education";
    description: string;
}[] = [
    {
        title: "News",
        slug: "news",
        description: `${process.env.NEXT_PUBLIC_SITE_DISPLAY_NAME}: Latest news and updates`,
    },
    // {
    //     title: "Education",
    //     slug: "education",
    //     description: "Educational content",
    // },
];

export const BLOG_AUTHORS = {
    johanna: {
        name: "Johanna",
        image: "/images/profile.webp",
        twitter: "johanna",
    },
    // shadcn: {
    //     name: "shadcn",
    //     image: "/_static/avatars/shadcn.jpeg",
    //     twitter: "shadcn",
    // },
};
